import React, { Component } from 'react';
import Avatar from "components/controls/uploadImage";
import AadhaarAvatar from 'components/controls/uploadAadhaar';
import _utils from '../../modules/Utils';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import { PROFILE_URL } from 'constants/constants';
import NavigationTab from './NavigationTab_new_one';
// Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): the Stage 3.2 shared Card
// replaces this page's 3 `.candidateform-cover` upload sections. `uploadImage`/`uploadAadhaar`
// themselves are untouched.
import Card from 'components/enterprise/Card';
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Stage 3.9 Phase E migration (imageSignature namespace): _notification.showMessage() calls happen
// inside class methods (not render), so those use the plain resolveText() helper — same idiom as
// NewLogin.jsx's validation-message comment.
function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class CandidateImageSignature_new extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            loading: false,
            profileImagePath: "",
            signatureImagePath: "",
            aadhaarImagePath: "",
            // Display-only. The *ImagePath fields above stay as the raw "container/blobname" value that
            // gets sent back on save — these hold the base64 preview separately, since the underlying
            // containers are now private and no longer directly linkable from the browser.
            profileImagePreview: "",
            signatureImagePreview: "",
            aadhaarImagePreview: ""
        };
    }

    componentDidMount() {

        this.getStudentImagesData();
    }

    getStudentImagesData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let response = await _StudentService.getStudentImagesData();
                    this.setState({
                        data: response.data,
                        profileImagePath: response.data.Profile_Pic_Path,
                        signatureImagePath: response.data.Signature_Path,
                        aadhaarImagePath: response.data.Aadhar_Img_Path,
                        profileImagePreview: response.data.Profile_Pic_Preview,
                        signatureImagePreview: response.data.Signature_Preview,
                        aadhaarImagePreview: response.data.Aadhar_Img_Preview,
                        loading: false
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    setProfileImage = async (selectedFile, profileImagePath) => {
        try {
            const body = new FormData();
            body.append('files[]', selectedFile);

            const response = await _StudentService.uploadProfileImage(body);
            if (response.data.IsSucess) {
                this.setState({
                    loading: false,
                    profileImagePath: _utils.getFileNameOfBlobURL(response.data.URL),
                    // Preview the file the browser already has locally — never depends on the (now
                    // private) blob container being reachable.
                    profileImagePreview: URL.createObjectURL(selectedFile),
                }, () => {
                    _notification.showMessage('success', tr('imageSignature.profileImageUploadSuccess'));
                })
            }
            else {
                this.setState({
                    loading: false
                }, () => {
                    _notification.showMessage('error', response.data.message);
                })
            }
        } catch (e) {
            // TODO
            console.log('Error: ', e);
        }
    };

    setSignatureImage = async (selectedFile, profileImagePath) => {
        try {
            const body = new FormData();
            body.append('files[]', selectedFile);

            const response = await _StudentService.uploadSignatureImage(body);
            if (response.data.IsSucess) {
                this.setState({
                    loading: false,
                    signatureImagePath: _utils.getFileNameOfBlobURL(response.data.URL),
                    signatureImagePreview: URL.createObjectURL(selectedFile),
                }, () => {
                    _notification.showMessage('success', tr('imageSignature.signatureUploadSuccess'));
                })
            }
            else {
                this.setState({
                    loading: false
                }, () => {
                    _notification.showMessage('error', response.data.message);
                })
            }
        } catch (e) {
            // TODO
            console.log('Error: ', e);
        }
    };

    setAadhaarImage = async (selectedFile, profileImagePath) => {
        try {
            const body = new FormData();
            body.append('files[]', selectedFile);

            const response = await _StudentService.uploadAadhaarImage(body);
            if (response.data.IsSucess) {
                this.setState({
                    loading: false,
                    aadhaarImagePath: _utils.getFileNameOfBlobURL(response.data.URL),
                    aadhaarImagePreview: URL.createObjectURL(selectedFile),
                }, () => {
                    _notification.showMessage('success', tr('imageSignature.aadhaarUploadSuccess'));
                })
            }
            else {
                this.setState({
                    loading: false
                }, () => {
                    _notification.showMessage('error', response.data.message);
                })
            }
        } catch (e) {
            // TODO
            console.log('Error: ', e);
        }
    };


    updateStudentImageData = async () => {
        try {
            this.setState({
                loading: true
            }, async () => {
                try {
                    let body = {
                        ...this.state.data,
                        Profile_Pic_Path: this.state.profileImagePath,
                        Signature_Path: this.state.signatureImagePath,
                        Aadhar_Pdf_Path: this.state.aadhaarImagePath
                    };
                    const response = await _StudentService.updateStudentImageData(body);
                    if (response.data.IsSuccess) {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('success', tr('imageSignature.allUploadsSuccess'));
                            localStorage[PROFILE_URL] = this.state.profileImagePreview;
                            this.onTabOrderChange();
                            //this.props.history.push({pathname: routes.registrationComplete.basePath, state: { applicationID: response.data.ApplicationId }})
                        })
                    }
                    else {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('error', response.data.message);
                        })
                    }
                } catch (e) {
                    // TODO
                    console.log('Error: ', e);
                }
            });

        } catch (e) { }
    }

    onTabOrderChange = () => {
        if (this.props.IsExamPaymentOnline) {
            this.props.onTabOrderChange(10);
        }
        else {
            this.props.onTabOrderChange(10);
        }
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    onPrevious = () => {
        this.props.onTabOrderChange(2);
    }

    //const StudentPersonalInfo = () => {
    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <>
                <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={3} />

                {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
                <div className="candidate-imagesignature ent-container gl-bxbr  analysisWrap p-4 mt-3">
                    <Text k="imageSignature.pageHeading" tag="h4" className="ch-heading4 mb-3" />
                    <Card header={<Text k="imageSignature.candidateImageUploadHeader" tag="h5" className="ch-heading5" />} className="candidate-imagesignature-wrap">
                        <div className="container-fluid  pr-0 pl-0  borderb">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ol>
                                        <Text k="imageSignature.imageInstruction1" tag="li" />
                                        <Text k="imageSignature.imageInstruction2" tag="li" />
                                        <Text k="imageSignature.imageInstruction3" tag="li" />
                                        <Text k="imageSignature.sizeLessThan1MB" tag="li" />
                                        <Text k="imageSignature.imageScanInstruction" tag="li" />
                                        <Text k="imageSignature.imageFormatInstruction" tag="li" />
                                    </ol>
                                </div>
                                <div className="col-sm-12 pb-3 EditProflePic">
                                    <Avatar
                                        srcImage={this.state.profileImagePreview}
                                        setImage={this.setProfileImage}
                                        uploadButtonText={<div className='displayInGrid'><Text k="imageSignature.uploadCandidateImage" /></div>}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>

                    <Card header={<Text k="imageSignature.candidateSignatureUploadHeader" tag="h5" className="ch-heading5" />} className="candidate-imagesignature-wrap">
                        <div className="container-fluid  pr-0 pl-0 borderb">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ol>
                                        <Text k="imageSignature.signatureInstruction1" tag="li" />
                                        <Text k="imageSignature.signatureInstruction2" tag="li" />
                                        <Text k="imageSignature.signatureInstruction3" tag="li" />
                                        <Text k="imageSignature.signatureInstruction4" tag="li" />
                                        <Text k="imageSignature.signatureDimensions" tag="li" />
                                        <Text k="imageSignature.sizeLessThan1MB" tag="li" />
                                        <Text k="imageSignature.signatureScanInstruction" tag="li" />
                                        <Text k="imageSignature.signatureFormatInstruction" tag="li" />
                                    </ol>
                                </div>
                                <div className="col-sm-12 pb-3 EditSignaturePic">
                                    <Avatar
                                        srcImage={this.state.signatureImagePreview}
                                        setImage={this.setSignatureImage}
                                        uploadButtonText={<div className='displayInGrid'><Text k="imageSignature.uploadCandidateSignature" /></div>}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>

                    <Card header={<Text k="imageSignature.candidateAadhaarUploadHeader" tag="h5" className="ch-heading5" />} className="candidate-imagesignature-wrap">
                        <div className="container-fluid  pr-0 pl-0 borderb">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ol>
                                        <Text k="imageSignature.aadhaarFormatInstruction" tag="li" />
                                        <Text k="imageSignature.aadhaarSizeInstruction" tag="li" />
                                    </ol>
                                </div>
                                <div className="col-sm-12 pb-3 EditSignaturePic ">
                                    <AadhaarAvatar
                                        srcImage={this.state.aadhaarImagePreview}
                                        setImage={this.setAadhaarImage}
                                        uploadButtonText={<div className='displayInGrid'><Text k="imageSignature.uploadCandidateAadhaar" /></div>}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className="row mt-4 footer-buttons">
                        <div className="col-12">
                            <div className=" form-action d-flex justify-content-end ">
                                <ButtonComponent
                                    id="btnCancel"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="imageSignature.cancelButton" /></div>}
                                    className="button-global button-border mr-4 autoHeight"
                                    onClick={this.onCancel} />

                                <ButtonComponent
                                    id="btnPrevious"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="imageSignature.previousButton" /></div>}
                                    className="button-global button-border mr-4 autoHeight"
                                    onClick={this.onPrevious} />

                                {(!this.state.loading && this.state.profileImagePath && this.state.signatureImagePath && this.state.aadhaarImagePath) &&
                                    <ButtonComponent
                                        id="btnSubmit"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="imageSignature.saveAndNext" /></div>}
                                        className="button-global button-primary autoHeight ml-4 "
                                        onClick={this.updateStudentImageData} />

                                }
                            </div>
                        </div>
                    </div>
                    {this.state.loading && <LoadingSpinner />}
                </div>
            </>
        )
    };
}

export default CandidateImageSignature_new;